import { Popover } from "@headlessui/react";
import React, { useContext, useEffect, useState } from "react";
import Navbar from "../components/navbar";
import BackButton from "../components/back_button";
import { AuthContext } from "../contexts/auth"
import { months, years } from "../config";
import { fetchEmployee, uploadBustePagaMassive, uploadCuSingolo } from "../services/api";
import { useParams } from "wouter";
import UploadForm from "../components/upload_form";

export default function UploadSingleCu() {
  
  const { codiceFiscale } = useParams();
  const { profile, token } = useContext(AuthContext)

  const [fetching, setFetching] = useState(true)
  const [employee, setEmployee] = useState(null)

  useEffect(() => {
    if (token && !fetching) {
      setFetching(true)
    }
    fetchEmployee(token, codiceFiscale)
      .then((res) => {
        setEmployee(res)
        setFetching(false)
      })
      .catch((err) => {
        console.log(err)
        setFetching(false)
      })
  }, [token])

  function buildYearChunk({ startYear, count }) {
    return Array.from({ length: count }, (_, i) => {
      const y = startYear - i;
      return { label: String(y), value: String(y) };
    });
  }

  const NOW_YEAR = new Date().getFullYear();
  const CHUNK = 15;

  const [yearOptions, setYearOptions] = useState(() =>
    buildYearChunk({ startYear: NOW_YEAR, count: CHUNK })
  );
  const minLoadedYear = Number(yearOptions[yearOptions.length - 1]?.value || NOW_YEAR);

  const loadMoreYears = () => {
    const nextStart = minLoadedYear - 1;
    const more = buildYearChunk({ startYear: nextStart, count: CHUNK });
    setYearOptions((prev) => {
      const existing = new Set(prev.map((o) => o.value));
      const filtered = more.filter((o) => !existing.has(o.value));
      return [...prev, ...filtered];
    });
  };
    

  return (
    <><div className="min-h-full">
      <main className="mt-10 pb-8">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          {/* back button */}
          <div className="flex items-center my-4">
            {
              employee ? <BackButton prevLocation={`/dipendenti/${employee.cf}`} /> : <BackButton prevLocation={`/dipendenti`} />
            }
          </div>
          {/* a div with a fake table */}
          <div className="">
            {fetching && (
              <>
                <div
                  className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <div role="status">
                    <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                      <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                    </svg>
                    <span className="sr-only">Loading...</span>
                  </div>
                  <span className="mt-2 block text-sm font-semibold text-gray-900">Caricamento...</span>
                </div>
              </>
            )}

            {(!fetching && employee) && (
              <>
              <div className="bg-white px-6 py-12 sm:py-12 lg:px-8 mb-10">
                <div className="mx-auto max-w-2xl text-center">
                  <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-2xl">
                    Carica una CU per {employee.first_name} {employee.last_name}
                    <br />
                    <small>
                      {employee.cf}
                    </small>
                  </h2>
                  <p className="mt-6 text-lg leading-8 text-gray-600">
                    {
                      employee.email
                    }
                  </p>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow overflow-hidden p-6 ">
            <UploadForm
              enableUpload={true}
                    fields={
                      [
                        { name: 'year', label: 'Anno', type: 'select', options: yearOptions, onScrollEnd: loadMoreYears },
                        { name: 'reference_year', label: 'Anno di Riferimento', type: 'select', options: yearOptions, disabled: true },
                        {
                          name: 'notify_employee', label: 'Notifica il dipendente via email', defaultChecked: true, type: 'checkbox', options: [
                            { label: 'Si', value: true },
                          ],
                        },
                        { type: 'hidden', name: 'anagrafica_create_missing', value: 'true' },
                        { type: 'hidden', name: 'typology', value: 'cu' },
                        { type: 'hidden', name: 'employee_id', value: employee.employee.id },
                      ]
                    }
              formType="CuSingole"
              submitLabel="Carica"
              submitAction={uploadCuSingolo}
            />
                </div></>)}
          </div>
        </div>
      </main>
    </div>
    </>
  )
}